module.exports = __webpack_public_path__ + "f532bf39d531af0eff0ef6dc2473eff8.svg";